export default __webpack_public_path__ + "static/media/Rectangle 408.1fd316e4.png";